import React, { useState } from "react";
import { Link } from "react-router-dom";
import useReactRouter from "use-react-router";

import Consts from "../../../consts";
import UploadPhoto from "../../../helpers/UploadPhoto";

import { FaAngleRight } from "react-icons/fa";
import { Modal, Container, Row, Col, Button, Form } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import BgCoverPrograme from "./BgCoverPrograme";

import Footer from "../../../components/footer";

import "./Index.css";

import Ws1 from "../../../image/programe/programe1/workshop/ws1.jpg";
import Ws2 from "../../../image/programe/programe1/workshop/ws2.jpg";
import Ws3 from "../../../image/programe/programe1/workshop/w3.jpg";
import Ws4 from "../../../image/programe/programe1/workshop/ws4.jpg";
import Ws5 from "../../../image/programe/programe1/workshop/ws5.JPG";

import Ws6 from "../../../image/programe/programe1/workshop/w6.jpg";
import Ws7 from "../../../image/programe/programe1/workshop/w7.jpg";
import Ws8 from "../../../image/programe/programe1/workshop/w8.jpg";
import Ws9 from "../../../image/programe/programe1/workshop/w9.jpg";
import Ws10 from "../../../image/programe/programe1/workshop/w10.jpeg";

function Programe1() {
  const { history } = useReactRouter();
  const { namePhoto, buttonUploadAndShowPhoto, setWidhtPhoto, setHeightPhoto } =
    UploadPhoto();
  const [showFormRegister, setShowFormRegister] = useState(false);

  const handleCloseFormRegister = () => setShowFormRegister(false);
  const handleShowFormRegister = () => setShowFormRegister(true);

  const images1 = [Ws1, Ws2, Ws3];
  const images2 = [Ws4, Ws5];
  const images3 = [Ws6, Ws7, Ws8];
  const images4 = [Ws9];
  const images5 = [Ws10];

  return (
    <div style={{ zIndex: 0 }}>
      <div style={{ height: 150 }} className="hideHeight"></div>

      <Container fluid className="m-0 p-0 mb-5 bgImage-about-pro">
        <Row className="m-0 p-0">
          <Col md="12" xs={12} className="m-0 p-0 banner-about-pro">
            {/* <img className='imgBg-about-pro' src={NewsCover} /> */}
            <BgCoverPrograme />

            {/* <div className="centered-about-pro">
                            <p className="proMainTitle">Our Program</p>
                        </div> */}

            <div className="container-list">
              <div
                className="list-items action-programe"
                onClick={() => history.push(Consts.PAGE_PROGRAME1)}
              >
                Campaign/ Workshop
              </div>
              <div
                className="list-items"
                onClick={() => history.push(Consts.PAGE_PROGRAME2)}
              >
                {" "}
                Research
              </div>
              <div
                className="list-items"
                onClick={() => history.push(Consts.PAGE_PROGRAME3)}
              >
                {" "}
                Capacity Building
              </div>
              <div
                className="list-items"
                onClick={() => history.push(Consts.PAGE_PROGRAME4)}
              >
                {" "}
                CSR Collaboration{" "}
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className="mt-5 ">
        <Row className="proFix1">
          <Col xs={12} className="p-5">
            <p className="proTitle">Awareness Campaign/ Workshop</p>
            <p className="proDetailTitle">
              The Eco School Champions Project: supported by UNICEF Laos, is a
              transformative initiative dedicated to advancing educational
              sustainability and environmental stewardship across the region. By
              fostering a deep-seated green mindset, the program empowers
              students and educators in Luang Prabang and Champasak provinces to
              take active roles in protecting their local ecosystems.
            </p>
            <p className="proDetailTitle">
              The project strategically integrates environmental education into
              formal school curricula, ensuring that sustainability becomes a
              core pillar of student learning rather than an extracurricular
              afterthought. Through hands-on activities and capacity-building
              workshops, participating institutions are transformed into model
              schools that demonstrate best practices in waste management,
              biodiversity, and climate resilience. By establishing these
              centers of excellence, the project creates a scalable framework
              for environmental literacy that can be replicated nationwide.
              Ultimately, the Eco School Champions Project seeks to equip the
              next generation of Lao leaders with the knowledge and conscience
              necessary to drive a sustainable and resilient future
            </p>
          </Col>
        </Row>

        <Row gutter={[12, 12]}>
          {images1.map((image, index) => (
            <Col
              key={index}
              xs={12}
              sm={4}
              md={4}
              style={{ margin: "10px 0px" }}
            >
              <img
                src={image}
                alt={`image-${index + 1}`}
                style={{
                  width: "100%",
                  height: 260,
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />
            </Col>
          ))}
        </Row>

        <Row>
          <Col xs={12} className="p-5">
            <p className="proDetailTitle">
              Youth-led Climate Action in Education for a Sustainable Future: In
              partnership with Plan International Laos and Germany, we are
              driving Youth-Led Climate Action in Education to secure a
              sustainable future for Laos. By implementing our innovative Youth
              Climate Action Model in Bokeo Province, we are transforming how
              young people engage with the environment. The project bridges the
              gap between classroom learning and real-world impact, training the
              next generation to lead the charge in climate adaptation and
              environmental protection
            </p>
          </Col>
        </Row>
        <Row gutter={[12, 12]}>
          {images2.map((image, index) => (
            <Col
              key={index}
              xs={12}
              sm={6}
              md={6}
              style={{ margin: "10px 0px" }}
            >
              <img
                src={image}
                alt={`image-${index + 1}`}
                style={{
                  width: "100%",
                  height: 260,
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />
            </Col>
          ))}
        </Row>

        <Row>
          <Col xs={12} className="p-5">
            <p className="proDetailTitle">
              The Eco Team: is the operational backbone of our initiative,
              powered by a dedicated network of 50 active members across Luang
              Prabang and Champasak provinces. This diverse group of youth
              leaders and educators serves as the project’s frontline,
              facilitating the transition toward sustainable "Model Schools"
              through a hands-on, community-driven approach. As the primary
              facilitators, the team ensures Eco School Champions activities are
              effectively implemented and environmental goals are deeply
              embedded in daily school operations. Through continuous
              mentorship, they equip students and teachers with practical skills
              in waste segregation, sustainable gardening, and energy
              conservation. Beyond the classroom, these 50 members act as
              ambassadors to mobilize the community, engaging parents and local
              authorities to support biodiversity and circular economy
              practices. Finally, the team manages monitoring and evaluation,
              tracking waste reduction data and lesson effectiveness to ensure
              the long-term sustainability and scalability of the "Model School"
              framework.
            </p>
          </Col>
        </Row>

        <Row gutter={[12, 12]}>
          {images3.map((image, index) => (
            <Col
              key={index}
              xs={12}
              sm={4}
              md={4}
              style={{ margin: "10px 0px" }}
            >
              <img
                src={image}
                alt={`image-${index + 1}`}
                style={{
                  width: "100%",
                  height: 260,
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />
            </Col>
          ))}
        </Row>

        {/* <Row>
          <Col xs={12} className="p-5">
            <p className="proDetailTitle">
              Governance in Water and Environment to Increase Resilience and
              Adaptation; (ENABLE) LAOS: funded by SIDA, in partnership with
              Helvetas to strengthen environmental governance and climate
              resilience. The project empowers youth-led CSOs and local
              authorities to become technically competent, accountable, and
              recognized leaders in the natural resource sector. By fostering a
              collaboration between young leaders and government duty-bearers,
              we codevelop climate action strategies and joint advocacy plans at
              the village and district levels. A significant portion of the
              project involves a sub-granting mechanism, allowing youth groups
              to implement practical community projects focused on water
              management and climate adaptation. We also amplify the impact of
              the Environmental Working Group (ESWG) by developing policy briefs
              and media partnerships to influence national decision-making.
              Ultimately, the project ensures social accountability and
              documents innovative Lao-led solutions to secure a sustainable,
              climate-resilient future.
            </p>
          </Col>
        </Row>

        <Row gutter={[12, 12]}>
          {images4.map((image, index) => (
            <Col
              key={index}
              xs={12}
              sm={12}
              md={12}
              style={{ margin: "10px 0px" }}
            >
              <img
                src={image}
                alt={`image-${index + 1}`}
                style={{
                  width: "100%",
                  height: 360,
                  objectFit: "contain",
                  borderRadius: 8,
                }}
              />
            </Col>
          ))}
        </Row> */}

        <Row>
          <Col xs={12} className="p-5">
            <p className="proDetailTitle">
              Inclusive Climate Finance for Vulnerable Communities in Asia
              Pacific (ICCAP): The Multi stakeholder Action Lab (MAL),
              implemented by Zero Waste Laos in partnership with the Stockholm
              Environment Institute (SEI), establishes a "living lab" in Laos to
              co-produce bankable, climate-resilient solutions. By convening
              vulnerable communities, green solution providers, and financial
              institutions, we bridge the gap between local adaptation needs and
              sustainable investment. Our core objectives include facilitating
              the co-design of innovative tools, like climate-smart agriculture,
              and transforming them into viable investment cases. Through this
              partnership, we work with Financial Service Providers to develop
              inclusive products, such as green microloans, that lower barriers
              for marginalized groups. Ultimately, the MAL fosters direct market
              linkages to scale high-impact technologies across the
              Asia-Pacific. This structured approach ensures that inclusive
              climate finance drives both environmental resilience and long-term
              economic stability for those most at risk in Laos
            </p>
          </Col>
        </Row>

        <Row gutter={[12, 12]}>
          {images5.map((image, index) => (
            <Col
              key={index}
              xs={12}
              sm={12}
              md={12}
              style={{ margin: "10px 0px" }}
            >
              <img
                src={image}
                alt={`image-${index + 1}`}
                style={{
                  width: "100%",
                  height: 360,
                  objectFit: "contain",
                  borderRadius: 8,
                }}
              />
            </Col>
          ))}
        </Row>
      </Container>

      <Footer />
    </div>
  );
}
export default Programe1;
